"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocales = exports.getLocale = exports.COUNTRIES_ISO_3 = exports.LOCALES = exports.DEFAULT_TMS_FORMAT = exports.DEFAULT_LOCALE = void 0;
exports.DEFAULT_LOCALE = 'de-DE';
exports.DEFAULT_TMS_FORMAT = 'de_DE';
exports.LOCALES = {
  en: {
    tmsFormat: 'en_US',
    cmsFormat: 'en',
    region: 'en',
    iso3: 'com'
  },
  'en-US': {
    tmsFormat: 'en_US',
    cmsFormat: 'en-us',
    region: 'en',
    iso3: 'com'
  },
  'de-DE': {
    tmsFormat: 'de_DE',
    cmsFormat: 'de-de',
    region: 'de',
    iso3: 'deu'
  },
  'en-GB': {
    tmsFormat: 'en_GB',
    cmsFormat: 'en-gb',
    region: 'gb',
    iso3: 'gbr'
  },
  'en-IE': {
    tmsFormat: 'en_IE',
    cmsFormat: 'en-ie',
    region: 'ie',
    iso3: 'irl'
  },
  'de-AT': {
    tmsFormat: 'de_DE',
    cmsFormat: 'de-at',
    region: 'at',
    iso3: 'aut'
  },
  'fr-FR': {
    tmsFormat: 'fr_FR',
    cmsFormat: 'fr-fr',
    region: 'fr',
    iso3: 'fra'
  },
  'es-ES': {
    tmsFormat: 'es_ES',
    cmsFormat: 'es-es',
    region: 'es',
    iso3: 'esp'
  },
  'nl-NL': {
    tmsFormat: 'nl_NL',
    cmsFormat: 'nl-nl',
    region: 'nl',
    iso3: 'nld'
  },
  'pl-PL': {
    tmsFormat: 'pl_PL',
    cmsFormat: 'pl-pl',
    region: 'pl',
    iso3: 'pol'
  }
};
exports.COUNTRIES_ISO_3 = {
  AUT: 'AUT',
  DEU: 'DEU',
  ESP: 'ESP',
  FRA: 'FRA',
  GBR: 'GBR',
  IRL: 'IRL',
  NLD: 'NLD',
  POL: 'POL'
};

var getLocale = function getLocale(locale) {
  var normalisedLocale = locale.toLowerCase() === 'en-us' ? 'en' : locale;
  return exports.LOCALES[normalisedLocale.toLowerCase()] || exports.LOCALES[normalisedLocale];
};

exports.getLocale = getLocale;

var getLocales = function getLocales() {
  return Object.keys(exports.LOCALES);
};

exports.getLocales = getLocales;